import { Component } from 'san';
import * as _ from 'lodash';

import { IAttachment, IUploaderErrorResponse } from 'src/models';

import auditService from 'src/services/audit.service';
import toasterService from 'src/services/toaster.service';
import uploaderService from 'src/services/uploader.service';
import userService from 'src/services/user.service';

export default class Attachment extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
    }

    initData(): {
        isDirty: boolean;
        isSystemAdmin: boolean;
        editEnable: boolean;    // {{}} init传入editEnable，则取editEnable，无值则取 !audit.actions.is_detail
        enforceDisabled: boolean;  // {{}} 强制禁用（任何人不得编辑，包括系统管理员）
        enforceBatchDownload: boolean;  // {{}} 强制显示”全部下载“
        auditId: string;    // {{}}
        attachments: IAttachment[]; // 流程附件
        _projectAttachments: IAttachment[];  // 项目私有附件
        isEditingAttachmentIndex: number; // 正在编辑的附件索引
    } {
        return {
            isDirty: false,
            isSystemAdmin: false,
            editEnable: undefined,
            enforceDisabled: false,
            enforceBatchDownload: false,
            auditId: null,
            attachments: [],
            _projectAttachments: [],
            isEditingAttachmentIndex: -1,
        };
    }

    inited() {
        const auditId = this.data.get('auditId');
        this.initAttachments(auditId);
        this.initIsSystemAdmin();
    }

    attached() {
        this.initUploader();
        document.addEventListener('click', (event) => {
            const input = document.querySelector('.attachment-input'); // attachment input
            const editIcon = document.querySelector('.fa.fa-edit'); // 编辑图标
            if (
                !(input && (event.target as Node).isEqualNode(input)) &&
                !(editIcon && (event.target as Node).isEqualNode(editIcon))
            ) {
              this.updateAttachmentName(); // 移除 Input 输入框
            }
        });
    }

    //#region owner调用
    getDataSync(): { items: IAttachment[] } {
        return { items: this.data.get('attachments') };
    }
    // 是否变更过
    getIsDirtySync(): boolean {
        return this.data.get('isDirty');
    }
    // 重置是否变更过
    resetIsDirtySync() {
        this.data.set('isDirty', false);
    }
    //#endregion

    initAttachments(auditId: string) {
      const attachments = this.data.get('attachments');
      const _projectAttachments = this.data.get('_projectAttachments');
      auditService.getAuditAttachmentInfo(auditId).then(attachmentInfo => {
            this.data.splice('attachments', [0, attachments.length, ...attachmentInfo.attachments.items]);
            this.data.splice('_projectAttachments', [0, _projectAttachments.length, ...attachmentInfo.projectAttachments.items]);
            const dataKey = 'editEnable';
            const editEnable = this.data.get(dataKey);
            // init传入editEnable，则取editEnable，无值则取 !audit.is_deleted && !audit.actions.is_detail
            if (_.isUndefined(editEnable)) {
                this.data.set(dataKey, attachmentInfo.edit_enable);
            }
        });
    }

    initIsSystemAdmin() {
        userService.getCurrentUserIsSystemAdmin().then(isSystemAdmin => {
            this.data.set('isSystemAdmin', isSystemAdmin);
        });
    }

    // 初始化文件上传
    initUploader() {
        uploaderService.show({
            isMultiple: true,
            selector: '#attachmentUploader',
            dnd: '.upload', // 可拖拽上传
            server: '/api/files/upload',
            errorCallback: (response: IUploaderErrorResponse) => {
                toasterService.show({
                    type: 'danger',
                    title: response.message,
                    contents: response.errors,
                });
            },
            finishedCallback: (attachments) => {
                if (!attachments.length) {
                    return;
                }
                attachments = _.forEach(attachments, attachment => _.pick(attachment, 'name', 'url_path'));
                const dataKey = 'attachments';
                const oldAttachments = this.data.get(dataKey);
                attachments = _.concat(oldAttachments, attachments);
                this.data.splice(dataKey, [0, oldAttachments.length, ...attachments]);
                toasterService.show({ type: 'success', title: '上传成功' });
                this.data.set('isDirty', true);
            }
        });
    }

    // 上传附件
    uploadAttachment() {
        const uploadEle = $(`#attachmentUploader input[type='file']`);
        uploadEle.click();
    }

    deleteAttachment(attachment: IAttachment) {
        const dataKey = 'attachments';
        const attachments = this.data.get(dataKey);
        const index = _.findIndex(attachments, { url_path: attachment.url_path });
        this.data.removeAt(dataKey, index);
        this.data.set('isDirty', true);
    }

    getDownloadAttachmentHref(attachment: IAttachment): string {
        return `${attachment.url_path}?downloadName=${encodeURIComponent(attachment.name)}`;
    }

    getBatchDownloadAttachmentsHref(): string {
        const auditId = this.data.get('auditId');
        return `/api/files/archive/workflow/${auditId}?name=${encodeURIComponent('附件')}`
    }

    // （系统管理员）更新流程附件
    updateFiles() {
        const auditId = this.data.get('auditId');
        const attachments = this.data.get('attachments');
        const _projectAttachments: IAttachment[] = this.data.get('_projectAttachments');
        auditService.updateAttachments(auditId, _.concat(_projectAttachments, attachments)).then(() => {
            toasterService.show({ type: 'success', title: '更新成功' });
        });
    }

    editAttachment(index: number) {
        this.data.set('isEditingAttachmentIndex', index);
    }

    updateAttachmentName() {
        this.data.set('isEditingAttachmentIndex', -1); // 移除 Input 输入框
    }

    handleKeyup(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        this.updateAttachmentName();
      }
      if (event.key === 'Escape') {
        this.data.set('isEditingAttachmentIndex', -1); // 移除 Input 输入框
      }
    }
}
